import * as actionTypes from "../actionTypes";

const initialState = {
    dailyDarshanData: [],
    consultantData: []
};

const religiousReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case actionTypes.SET_DAILY_DARSHAN:
            return { ...state, dailyDarshanData: payload, };
        case actionTypes.SET_CONSULTANT_DATA:
            return { ...state, consultantData: payload};
        default:
            return state;
    }
};

export default religiousReducer;